import { createContext } from "react";

const usuarioContext = createContext();

export default usuarioContext;
